import React from "react";
import BusinessCentralCustomerRows from "./BusinessCentralCustomerRows";
import LinkBusinessCentralCustomer from "./LinkBusinessCentralCustomer";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import InPageEditableFieldWithLabel from "components/MainSectionTemplate/InPageEditableFieldWithLabel";
import { SectionTemplateHeader } from "components/MainSectionTemplate/SectionTemplateHeader";
import { CompanyFormState } from "shared/utils/fieldsHelper/companyFields";

interface Props {
  businessCentralNumber: string
  companyFormState: CompanyFormState
}

export const BusinessCentralSection = (props: Props) => {
  const [businessCentralNumber, setBusinessCentralNumber] = React.useState(props.businessCentralNumber);
  const [isLinkModalOpen, setIsLinkModalOpen] = React.useState(false);

  const openLinkModal = () => {
    setIsLinkModalOpen(true);
  };

  const onUnlink = () => {
    window.displayDeleteConfirmationModal({
      onDeleteHandler: async () => {
        await window.CoreApi.Company.SetBusinessCentralNumber({ companyId: props.companyFormState.companyId, businessCentralNumber: null });
        setBusinessCentralNumber(null);
      }
    })
  }

  const hasBusinessCentralNumber = businessCentralNumber != null;

  return <SectionPanel.Panel
    key="businessCentralSection"
    collapsible={{
      start: "open",
      uniqueRowId: "businessCentralSection",
      persist: true,
    }}
    header={<SectionTemplateHeader>Business Central</SectionTemplateHeader>}
  >
    <div className="main-section-template-grid">
      <InPageEditableFieldWithLabel
        compact={false}
        field={{
          key: "businessCentralNumber",
          label: RESX.GeneralLabels.Number,
          render: () => hasBusinessCentralNumber ? <div>{businessCentralNumber}</div> : <a onClick={openLinkModal}>{RESX.Buttons.btnSearch}</a>,
        }}

      />
      <BusinessCentralCustomerRows businessCentralNumber={businessCentralNumber} companyFormState={props.companyFormState} onUnlink={onUnlink} />
    </div>

    <LinkBusinessCentralCustomer
      companyId={props.companyFormState.companyId}
      isLinkModalOpen={isLinkModalOpen}
      handleLinkModalClose={() => { setIsLinkModalOpen(false); }}
      onLinked={(businessCentralNumber) => {
        setBusinessCentralNumber(businessCentralNumber);
        setIsLinkModalOpen(false);
      }}
    />
  </SectionPanel.Panel>
};